import React, { useMemo, useState } from "react";
import styles from "./PermArrayChips.module.css";

function normalizeList(list) {
    const cleaned = (Array.isArray(list) ? list : [])
        .map(v => String(v ?? "").trim())
        .filter(Boolean);

    const unique = [...new Set(cleaned)];
    const allNumeric = unique.every(v => /^\d+$/.test(v));

    if (allNumeric) unique.sort((a, b) => Number(a) - Number(b));
    else unique.sort((a, b) => a.localeCompare(b, "pt-BR"));

    return unique;
}

export default function PermArrayChips({ value, onChange, label, placeholder = "Digite e pressione Enter" }) {
    const list = useMemo(() => normalizeList(value), [value]);
    const [input, setInput] = useState("");

    const add = (raw) => {
        const parts = String(raw ?? "")
            .split(",")
            .map(s => s.trim())
            .filter(Boolean);

        if (!parts.length) return;

        const merged = normalizeList([...list, ...parts]);
        onChange(merged);
        setInput("");
    };

    const remove = (item) => {
        onChange(list.filter(x => x !== item));
    };

    return (
        <div className={styles.box}>
            <div className={styles.top}>
                <div className={styles.label}>{label}</div>
                <div className={styles.count}>{list.length}</div>
            </div>

            <div className={styles.chips}>
                {list.map((item) => (
                    <button
                        type="button"
                        key={item}
                        className={styles.chip}
                        onClick={() => remove(item)}
                        title="Remover"
                    >
                        {item} <span className={styles.x}>×</span>
                    </button>
                ))}
                {!list.length ? <div className={styles.empty}>Nenhum item</div> : null}
            </div>

            <input
                className={styles.input}
                value={input}
                placeholder={placeholder}
                onChange={(e) => setInput(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") {
                        e.preventDefault();
                        add(input);
                    }
                }}
                onBlur={() => add(input)}
            />

            <div className={styles.hint}>Dica: você pode colar “1,2,3” de uma vez.</div>
        </div>
    );
}